import { Stack, Text, Heading } from '@chakra-ui/react';

const UIKIT = () => (
    <div>
        <Stack spacing={3}>
            <Text fontSize="6xl">(6xl) In love with React & Next</Text>
            <Text fontSize="5xl">(5xl) In love with React & Next</Text>
            <Text fontSize="4xl">(4xl) In love with React & Next</Text>
            <Text fontSize="3xl">(3xl) In love with React & Next</Text>
            <Text fontSize="2xl">(2xl) In love with React & Next</Text>
            <Text fontSize="xl">(xl) In love with React & Next</Text>
            <Text fontSize="lg">(lg) In love with React & Next</Text>
            <Text fontSize="md">(md) In love with React & Next</Text>
            <Text fontSize="sm">(sm) In love with React & Next</Text>
            <Text fontSize="xs">(xs) In love with React & Next</Text>
        </Stack>
        <Stack spacing={6}>
            <Heading as="h1" size="4xl" noOfLines={1}>
                (4xl) In love with React & Next
            </Heading>
            <Heading as="h2" size="3xl" noOfLines={1}>
                (3xl) In love with React & Next
            </Heading>
            <Heading as="h2" size="2xl">
                (2xl) In love with React & Next
            </Heading>
            <Heading as="h2" size="xl">
                (xl) In love with React & Next
            </Heading>
            <Heading as="h3" size="lg">
                (lg) In love with React & Next
            </Heading>
            <Heading as="h4" size="md">
                (md) In love with React & Next
            </Heading>
            <Heading as="h5" size="sm">
                (sm) In love with React & Next
            </Heading>
            <Heading as="h6" size="xs">
                (xs) In love with React & Next
            </Heading>
        </Stack>
    </div>
);

export default UIKIT;
